import { addQuotes } from '../utils/smartutils';

export default function listUnconsolidatedCycleClosingForField(
  cycleNumber,
  classId,
  periodId
) {
  return `{
  listUnconsolidatedCycleClosing(
    cycleNumber: ${cycleNumber}, 
    classId: ${classId}, 
    periodId: ${periodId}) {
      id
      label
      value     
  }
}`;
}

export function listConsolidatedCycleClosing(
  cycleNumber,
  classId,
  statusClass
) {
  return `{
 listConsolidatedCycleClosing(
    cycleNumber: ${cycleNumber}
    classId: ${classId}
    statusClass: ${addQuotes(statusClass)}
    )
    {
        students {
            id, 
            name, 
            reportId,
            data {
                id,
                name,
                frequency,
                average,
                absences
            }
        }
        subjects {
            id, 
            name, 
            data {
                id,
                name,
                frequency,
                average,
                absences
            }
        }
    }
}`;
}

export function cycleEndingSaveMutation(values) {
  return `mutation{
    cycleEndingSave(
        cycleEnding: {
            id: ${values.id || 0}
            period: {
                id: ${values.schoolTerm.id}
                year: 0
                filterByStatus: false
                updaterId: 0
                initialDate: 0
                finalDate: 0
            }
            course: {
                id: ${values.course.id}
                excluded: false
                updaterId: 0
                useGridSchedule: false
                active: true
            }
            courseStep: {
              id: ${values.courseStep.id}
              cycleQuantity: 0
            }
            cycleNumber: ${values.cycleNumber.value}
            cycleClosed: ${values.cycleClosed}
            statusClass : []
        }
    )
    {
        id, 
        cycleClosed
    }
}`;
}

export function findCycleEndingById(id) {
  return `{findCycleEndingById(id: ${id}) {
      id
      course {
        id
        name
        minFrequency
        mediaApproval
      }
      courseStep {
        id
        cycleQuantity
      }
      period {
        id
        name
      }
      cycleNumber
      cycleClosed
    }
}`;
}

export function findAllCycleEnding() {
  return `{
  findAllCycleEnding {
    id
    course {
      id
      name
    }
    courseStep {
      id
      fullName
    }
    period {
      id
      name
    }
    cycleNumber
    cycleClosed
  }
}
`;
}
